import { motion } from "framer-motion";
import useOnceInView from '../hooks/useOnceInView'


const CoreCards = ({core, index}) => {
      const { ref, isInView } = useOnceInView();
        const rightcomp = core.id % 2 === 0;
    if (core.value) {
        return (<motion.div
                                ref={ref}
                                 className='bg-white xs:w-[400px] w-[600px] relative group'
                                 initial={{x: rightcomp ? -100 : 100, z: rightcomp ? 0 : 30}}
                                 animate={isInView ? {x: 0, z: 0}: {}}
                                 transition={{duration: 0.8, delay:0, ease: 'easeInOut'}}
                                 >

                                    {/* shadow */}
                                    <div className='bg-[#D582E3] w-full h-[85%] absolute -bottom-4 left-6 rotate-[4deg] rounded-lg group-hover:rotate-[-4deg] transition-transform duration-500 ease-out'></div>

                                    {/* card shell  */}
                                    <div className=" relative z-10 w-full h-full rounded-lg border-2 border-[#aa96da] overflow-hidden bg-white">
                                        <div className='w-full h-full text-xl flex flex-col gap-3 z-30 p-3 pb-5 relative rounded-lg border-2 border-solid border-[#aa96da] hover:bg-[#f3e5f5]'>
                                            <h2 className='font-garamond text-heading-color text-3xl'>{core.title}</h2>
                                            <p className='font-montserrat text-heading-color font-demibold italic leading-loose text-xl'>{core.subtitle}</p>
                                            <p className='font-montserrat text-text-color leading-loose text-xl'>{core.desc}</p>
                                            <div>
                                                <h3 className='font-montserrat text-heading-color w-full font-demibold text-xl'>What We Offer:</h3>
                                                <ul className='pl-8 flex flex-col gap-3 text-xl'>
                                                    {core.offers?.map((offer, index) => (
                                                        <li key={index} className='font-montserrat text-text-color list-disc'>{offer}</li>
                                                    ))}
                                                    </ul>
                                            </div>
                                            <h3 className=' text-xl font-semibold font-montserrat'>Impact: <span className='font-montserrat text-text-color leading-loose text-xl font-[400]'>{core.impacts}</span></h3>
                                        </div>
                                    </div>
                                </motion.div>
                            )
    } else {
        return (
            <motion.div
                                ref={ref}
                                 key={index} 
                                 className='bg-white w-[600px] relative group'
                                 initial={{x: -100, z: 0}}
                                 animate={isInView ? {x: 0, z: 0}: {}}
                                 transition={{duration: 1.2, delay:0, ease: 'easeInOut'}}
                                 >
                                    <div className='bg-[#D582E3] w-[95%] h-[90%] absolute -bottom-4 left-9 rotate-[4deg] rounded-lg group-hover:rotate-[-4deg] transition-transform duration-500 ease-out'></div>
                                    
                                    {/* card shell  */}
                                    <div className=" relative z-10 w-full h-full rounded-lg border-2 border-[#aa96da] overflow-hidden bg-white">
                                        <div className='w-full h-full flex flex-col gap-3 z-30 p-3 pb-5 relative rounded-lg border-2 border-solid border-[#aa96da] hover:bg-[#f3e5f5]'>
                                        <h2 className='font-garamond text-heading-color text-2xl'>{core.title}</h2>
                                        <p className='font-montserrat text-heading-color font-demibold italic xl leading-loose text-xl' >{core.subtitle}</p>
                                        <p className='font-montserrat text-text-color leading-loose text-xl'>{core.desc}</p>
                                        <div>
                                            <h3 className='font-montserrat text-heading-color text-xl font-semibold'>Industries We Serve</h3>
                                            <div className='flex flex-col gap-2 mt-2'>
                                            {Object.entries(core.industries || {}).map((indu, index) => (
                                                <div key={index}>
                                                    <span className='font-montserrat text-heading-color font-demibold text-xl text-lx'>{indu[0]}</span>: <span className='font-montserrat text-text-color text-xl font-[400] leading-loose'>{indu[1]}</span>
                                                </div>
                                            ))}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </motion.div>
        )
    }
}

export default CoreCards;